import Swiper, { Pagination } from "swiper";
import "swiper/scss";
import "swiper/scss/pagination";

let slidersMobile = [];
let elements;
const sliderMobileArgs = {
  // configure Swiper to use modules
  modules: [Pagination],
  loop: true,
  loopFillGroupWithBlank: true,
  spaceBetween: 20,
  centeredSlides: true,
  autoHeight: true,
  // enabled: false,

  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
};

const BlockSlider = ($) => {
  elements = $(".swiper");

  initMobile($);
  initDesktop($);
  $(window).on("resize", () => {
    initMobile($);
    initDesktop($);
  });
};

const initMobile = ($) => {
  // Destroy on desktop
  if (window.matchMedia("(min-width: 1024px)").matches) {
    slidersMobile.forEach((slider) => {
      slider.destroy();
    });
    slidersMobile = [];
  }
  // Enable on mobile
  else {
    if (slidersMobile.length === 0) {
      elements.each((id, el) => {
        slidersMobile[id] = new Swiper(el, sliderMobileArgs);
      });
    }
  }
};

const initDesktop = ($) => {
  // Enable on desktop
  if (window.matchMedia("(min-width: 1024px)").matches) {
    $(".wp-block-seven-shapes-slider-item").on("click", (e) => {changeSlide(e, $)})
  }
  // Reset on mobile
  else {
    $(".wp-block-seven-shapes-slider-item").off("click");
  }
}

const changeSlide = (e, $) => {
  const el = $(e.currentTarget);
  const id = el.data("id");
  const slider = el.parents(".wp-block-seven-shapes-slider");
  const imagesWrapper = $(".wp-block-seven-shapes-slider__images", slider);

  // Deactivate old image
  $(".wp-block-seven-shapes-slider__media.active", imagesWrapper).removeClass("active");
  // Activate new image
  $(".wp-block-seven-shapes-slider__media", imagesWrapper).eq(id - 1).addClass("active");
  
  // Deactivate old image
  $(".wp-block-seven-shapes-slider-item--active", slider).removeClass("wp-block-seven-shapes-slider-item--active");
  // Activate new image
  $(".wp-block-seven-shapes-slider-item", slider).eq(id - 1).addClass("wp-block-seven-shapes-slider-item--active");

}

export default BlockSlider;
